























import Vue from "vue";
import Lottie from "vue-lottie";
import * as successData from "@/assets/lottie/success.json";
import * as failData from "@/assets/lottie/fail.json";
import { EventEmitter } from "@/js/EventEmitter";
import { EventLogger } from "@/js/EventLogger";
import { Utils } from "@/js/Utils";

export default Vue.extend({
  name: "Result",
  components: {
    Lottie
  },
  data() {
    return {
      showLog: this.$route.query.debug === "true",
      logCopied: false
    };
  },
  props: {
    success: Boolean,
    logs: String
  },
  async mounted() {
    if (!this.success) {
      EventEmitter.fail(this.tipCode, this.allLogs);
    }
    if (this.success) {
      const hasVideoInputDevice = await Utils.hasVideoInputDevice();
      EventLogger.singleton.sendResultSuccessEvent(hasVideoInputDevice);
    } else {
      EventLogger.singleton.sendResultFailEvent(this.tipCode);
    }
  },
  computed: {
    title(): string {
      return this.$t(`challenge.result.${this.success ? "success" : "fail"}.title`) + "";
    },
    message(): string {
      return this.$t(`challenge.result.${this.success ? "success" : "fail"}.message`) + "";
    },
    buttonText(): string {
      return this.$t(`challenge.result.${this.success ? "success" : "fail"}.buttonText`) + "";
    },
    lottieOptions(): any {
      return {
        // @ts-ignore
        animationData: this.success ? successData.default : failData.default,
        loop: false
      };
    },
    allLogs(): string {
      return `Remote logs:\n${this.logs || "no logs"}\n---\nLocal logs:\n${JSON.stringify(
        (window as any).allLocalLogs || "no logs",
        null,
        2
      )}`;
    },
    tips(): string {
      if (this.success) {
        return "";
      }
      if (this.tipCode == null) {
        return "";
      }
      return this.$tc(`challenge.result.tips.${this.tipCode}`);
    },
    tipCode(): string | null {
      if (this.allLogs.includes("AreaState fail: no move")) {
        return "face_area_fail";
      }
      if (this.allLogs.includes("AreaState fail: blurred")) {
        return "blurred_camera_in_area_state";
      }
      if (this.allLogs.includes("fail: state FaceUpState timed out")) {
        return "faceup_overtime";
      }
      if (this.allLogs.includes("GENERAL: Overtime!!!") || this.allLogs.includes("fail: state NoseState timed out")) {
        return "nose_overtime";
      }
      if (this.allLogs.includes("AREA: min_face_area: False")) {
        return "min_face_area_message";
      }
      if (this.allLogs.includes("NOSE: face NOT rotated")) {
        return "face_not_rotated";
      }
      if (
        this.allLogs.includes("FACE: rekMetadata count:") ||
        this.allLogs.includes("FaceState fail. More than one face detected")
      ) {
        return "more_than_one_face";
      }
      if (this.allLogs.includes("NoseState fail: isFaceBoxInsideFaceArea=false")) {
        return "face_is_not_in_box";
      }
      if (this.allLogs.includes("Local failed: May be backlit")) {
        return "maybe_backlit";
      }
      if (this.allLogs.includes("Local failed: Not enough light")) {
        return "not_enough_light";
      }

      if (this.allLogs.includes("NoseState fail: #faces=0")) {
        return "no_faces_detected";
      }
      return null;
    }
  },
  methods: {
    activateDebug() {
      this.showLog = true;
    },
    copyLog() {
      navigator.clipboard.writeText(this.allLogs);
      this.logCopied = true;
    },
    onConfirmButtonClick() {
      this.$emit(this.success ? "finish" : "restart");
      (window as any).allLocalLogs = [];
    }
  }
});
